module.exports = __webpack_public_path__ + "static/media/22-9.9597defb.mp3";